import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseTokenService } from '../services/base-token.service';
import { AuthService, PortalService } from '../../../api';

@Injectable()
export class BaseAuthInterceptor implements HttpInterceptor {
  private AUTH_HEADER = 'Authorization';
  private AUTH_EXCLUDED_ENDPOINTS = [
    AuthService.PostAppApiAuthAuthTokenrefreshingPath,
    AuthService.PostAppApiAuthAuthLogoutPath,
    PortalService.GetPortalSettingShowPath,
  ];

  constructor(private tokenService: BaseTokenService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.shouldSkipAuth(req)) {
      return next.handle(req);
    }

    const authRequest = this.addAuthenticationToken(req);
    return next.handle(authRequest);
  }

  private addAuthenticationToken(request: HttpRequest<any>): HttpRequest<any> {
    if (!this.tokenService.getToken()) {
      return request.clone({
        withCredentials: true,
      });
    }

    return request.clone({
      headers: request.headers.set(this.AUTH_HEADER, 'Bearer ' + this.tokenService.getToken()),
      withCredentials: true,
    });
  }

  private shouldSkipAuth(req: HttpRequest<any>): boolean {
    return this.AUTH_EXCLUDED_ENDPOINTS.some((segment) => req.url.includes(segment));
  }
}
